import { Component, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UserService } from './services/user.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class AppComponent {
  protected readonly title = signal('Dhamnagar Development Dashboard (D3)');
  private userService = inject(UserService);

  constructor() {
    // Seed master accounts logic is disabled for normal users to prevent
    // permission errors and Firebase Auth session interference on refresh.
    if (!localStorage.getItem('ppms_seeded_v6')) {
      localStorage.setItem('ppms_seeded_v6', 'true');
      
      // If we ever want to re-enable client-side seeding, it should only 
      // be triggered manually by an Admin in a specific setup page,
      // not automatically on app bootstrap.
      console.log('App initialized.');
    }
  }
}
